export const reload = () => {
    window.location.reload()
}

export const openNewTab = (path) => {
    const url = window.location.origin + "/" + path;
    window.open(url, '_blank');
};